"use strict";

exports.__esModule = true;
exports.calcDexPrice = calcDexPrice;
exports.calcDexPriceAndAmountFormPool = calcDexPriceAndAmountFormPool;
var _sdkCore = require("@acala-network/sdk-core");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
function calcDexPriceAndAmountFormPool(target, detail, wallet) {
  const [token0, token1] = detail.info.pair;
  const [amount0, amount1] = detail.amounts;
  const baseToken = target.isEqual(token0) ? token1 : token0;
  if (!wallet.subscribePrice) return (0, _rxjs.of)([target.isEqual(token0) ? amount0 : amount1, _sdkCore.FixedPointNumber.ZERO]);
  return wallet.subscribePrice(baseToken).pipe((0, _operators.map)(price => {
    const rate = target.isEqual(token0) ? amount1.div(amount0) : amount0.div(amount1);
    return [target.isEqual(token0) ? amount0 : amount1, price.mul(rate)];
  }));
}
function calcDexPrice(target, details, wallet) {
  return (0, _rxjs.combineLatest)(details.map(i => calcDexPriceAndAmountFormPool(target, i, wallet))).pipe((0, _operators.map)(prices => {
    const zero = new _sdkCore.FixedPointNumber(0, target.decimals);
    const total = prices.reduce((acc, cur) => acc.add(cur[0]), zero);
    const weightAveragePrice = prices.reduce((acc, cur) => acc.add(cur[1].mul(cur[0].div(total))), zero);
    return weightAveragePrice;
  }));
}